import store from "../store/index";
import axios from "axios";
import router from "../router";

console.log(localStorage.getItem('CF_DEFORESTATION_BASE_URL'), "------ start of DEFORESTATION BASE URL from GraphQLService.js");
let DEFORESTATION_BASE_URL = (localStorage.getItem('CF_DEFORESTATION_BASE_URL') ||
  process.env.VUE_APP_DEFORESTATION_BASE_URL ||
  "https://cf-deforestation.dimitra.dev/graphql").replace(/^['"]+|['"]+$/g, '');

import { deforestationBaseUrl } from "@/config/endpoints";

const ttk = localStorage.getItem('token');
const axiosConfig = {
    baseURL: DEFORESTATION_BASE_URL,
    headers: {
        'Content-Type': 'application/json',
        authorization: ttk || store?.getters?.getAuthToken,
        screensize: `${window.outerWidth}x${window.outerHeight}`,
        timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
        lang: localStorage.getItem("LANGUAGE") ?? 'en',
    }
};

const axiosInstance = axios.create(axiosConfig);

axiosInstance.interceptors.request.use(axiosConfig, error => {
  return Promise.reject(error);
});

axiosInstance.interceptors.request.use(
  (config) => {
    const storageToken = localStorage.getItem('token');
    const authToken = storageToken || store.getters.getAuthToken;
    config.headers['authorization'] = authToken || store.getters.getAuthToken;
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

async function callPostAPI(query, variables){
  const result = await axiosInstance.post(
    DEFORESTATION_BASE_URL,
    {
      query,
      variables,
    }
  );
  return result.data;
}

// Several components on one page often request the same query at the same time
// (e.g. getDiligenceDetail from the wizard shell and the active step). Identical
// in-flight queries share one request. Nothing is cached after it settles, and any
// write bumps the generation so a query issued after a save never joins a request
// that started before it.
const inFlightQueries = new Map();
let writeGeneration = 0;

const markWrite = () => { writeGeneration += 1; };

axios.interceptors.request.use((config) => {
  if ((config.method || 'get').toLowerCase() !== 'get') markWrite();
  return config;
});

const isMutation = (query) => /^\s*mutation\b/.test(query || '');

// Heavy read-only queries that one page load requests several times in sequence
// (DDS wizard shell, store, warnings, Final Report). A settled result is reused for a
// few seconds; any write bumps the generation and makes it unreachable.
const SHORT_CACHE_OPERATIONS = new Set(['GetDiligenceDetail', 'eudrSetting', 'DeforestationProductList']);
const SHORT_CACHE_TTL_MS = 5000;
const recentResults = new Map();

const operationName = (query) => (/^\s*query\s+(\w+)/.exec(query || '') || [])[1] || null;

const cloneResult = (data) => {
  try {
    return JSON.parse(JSON.stringify(data));
  } catch (e) {
    return data;
  }
};

async function postGraphqlQuery(query, variables, retry = true) {
  if (isMutation(query)) {
    markWrite();
    return sendGraphqlQuery(query, variables, retry);
  }
  const token = localStorage.getItem('token') || store.getters.getAuthToken || '';
  const key = [
    writeGeneration,
    token,
    localStorage.getItem("LANGUAGE") ?? 'en',
    query,
    JSON.stringify(variables ?? null),
  ].join('\u0000');
  const cacheable = SHORT_CACHE_OPERATIONS.has(operationName(query));
  if (cacheable) {
    const recent = recentResults.get(key);
    if (recent && recent.expiresAt > Date.now()) {
      return Promise.resolve(cloneResult(recent.data));
    }
    recentResults.delete(key);
  }
  const pending = inFlightQueries.get(key);
  if (pending) {
    return pending.then(cloneResult);
  }
  const request = sendGraphqlQuery(query, variables, retry).then((data) => {
    if (cacheable && !data?.errors?.length) {
      for (const [cachedKey, entry] of recentResults) {
        if (entry.expiresAt <= Date.now()) recentResults.delete(cachedKey);
      }
      recentResults.set(key, { data, expiresAt: Date.now() + SHORT_CACHE_TTL_MS });
    }
    return data;
  }).finally(() => {
    inFlightQueries.delete(key);
  });
  inFlightQueries.set(key, request);
  return request.then(cloneResult);
}

async function sendGraphqlQuery(query, variables, retry = true) {
  DEFORESTATION_BASE_URL = deforestationBaseUrl();
  try {
    console.log("variables", variables)    
    const result = await axiosInstance.post(
      DEFORESTATION_BASE_URL,
      {
        query,
        variables,
      }
    );
    return result.data;
  } catch (error) {
    const token = store.getters.getAuthToken;
    // Map dev errors to user messages
    const devMessage = error.response?.data?.errors?.[0]?.message;
    let userMessage = "Something went wrong. Please try again later.";

    if (error.response?.status === 500 && token && retry) {
      const message = error.response?.data?.errors?.[0]?.message?.toLowerCase();

      // Retry only if message says token is invalid/expired
      if (message?.includes("invalid token") || message?.includes("context creation failed")) {
        try {
          await store.dispatch("refreshToken");

          // Retry with updated token
          return await sendGraphqlQuery(query, variables, false);
        } catch (err) {
          await store.dispatch("logout");
          router.push("/login");
          userMessage = "Session expired. Please log in again.";
        }
      }

      userMessage = "Something went wrong on the server. Please try again later.";
    }
    if (error.response?.data?.errors?.length && error.response?.data?.errors[0].statusCode === 401 && token) {
      try{
        await store.dispatch('refreshToken');
        // console.log( error.response);
        return await callPostAPI(query,variables)

      }catch(err){
        // console.log('rf', err);
        await store.dispatch('logout');
        router.push('/login')
      }
    }

    if (error.response?.data?.errors?.length && error.response?.data?.errors[0].statusCode === 403 && token) {
      router.push({name: 'AdminDashboard'})
    }

    console.error(devMessage);
    return Promise.reject(userMessage);
  }
}

export {
    postGraphqlQuery,
    axiosConfig
};